module.exports = __webpack_public_path__ + "img/42_5.0048ac53.png";